import { render, staticRenderFns } from "./VSideForm.vue?vue&type=template&id=e1257e52&"
import script from "./VSideForm.vue?vue&type=script&lang=ts&"
export * from "./VSideForm.vue?vue&type=script&lang=ts&"
import style0 from "./VSideForm.vue?vue&type=style&index=0&id=e1257e52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports